import revista_banner from "../../assets/images/inicio/revista banner.png";
import banner from "../../assets/images/inicio/imagen banner.jpg";
import "./BannerTop.css";

const BannerTop = () => {
  return (
    <div className="banner-top-container">
      <img
        src={banner}
        alt="Fondo"
        className="background-banner"
        loading="lazy"
      />
      <div className="banner-content">
        <img
          src={revista_banner}
          alt="Sobre portada"
          className="revista-banner"
          loading="lazy"
        />
        <div className="banner-text">
          Tu Guía en el Mundo del Transporte
          {/* <br />
          Transporte */}
        </div>
      </div>
    </div>
  );
};

export default BannerTop;
